import * as Types from '../constants/actionTypes';
const defaultState = {
    isPending: false,
    models: [],
    message: '',
    count: 0,
    selectedModel: {
        id: null,
        name: ""
    },
    isStartUpdate: false,
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case Types.MODELS_FETCHED:
            return {
                ...state,
                models: action.payload.data,
            }
        case Types.MODEL_UPDATE:
            return {
                ...state, isStartUpdate: true, selectedModel: action.payload.data,
            }
        case Types.MODEL_UPDATE_CANCEL:
            return {
                ...state, isStartUpdate: false, selectedModel: { id: null, name: "" },
            }
        case Types.MODEL_UPDATED:
            const updateModel = state.models.find(m => m.id === action.payload.data.id);
            updateModel.name = action.payload.data.name;
            return{
                ...state, isStartUpdate: false, message: action.payload.message, selectedModel: { id: null, name: "" }
            }
        case Types.MODEL_ADDED:
            return {
                ...state, isStartUpdate: false, message: action.payload.message, selectedModel: { id: null, name: "" }
            }
        case Types.MODEL_DELETED:
            return {
                ...state,
                models: state.models.filter(m => m.id !== action.payload.data),
                message: action.payload.message
            }
        case Types.MODEL_ERROR:
            return {
                ...state,
                message: action.payload.message
            }
        case Types.MODELS_COUNTED:
            return{
                ...state, count: action.payload.data
            }
        case Types.MODEL_SET_MESSAGE:
            return {
                ...state,
                message: action.payload.message,
            }            
        default:
            return state
    }
}
